import { useState } from "react";
import { toast } from "sonner";
import { publicApi, formatPublicError, isValidMobile, honeypotOf } from "../../lib/publicApi";
import { useT } from "../../lib/i18n";

import { tr } from "../../lib/i18n";
export default function SellYourCarPage() {
  const { t } = useT();
  const [form, setForm] = useState({ name: "", mobile: "", email: "", make: "", model: "", year: "", mileage: "", condition_notes: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!isValidMobile(form.mobile)) { toast.error(t("enquiry.mobile_invalid")); return; }
    setSending(true);
    try {
      await publicApi.post("/enquiries", {
        kind: "sell",
        honeypot: honeypotOf(e),
        name: form.name, mobile: form.mobile, email: form.email,
        message: tr("x.sell_request_km", { p0: form.year, p1: form.make, p2: form.model, p3: form.mileage, p4: form.condition_notes }),
        sell: {
          make: form.make, model: form.model,
          year: parseInt(form.year) || null,
          mileage: parseInt(form.mileage) || null,
          condition_notes: form.condition_notes,
        },
      });
      toast.success(t("enquiry.success"));
      setDone(true);
    } catch (err) {
      toast.error(formatPublicError(err));
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div className="public-container" style={{ padding: "80px 20px", textAlign: "center", maxWidth: 600 }}>
        <div className="section-eyebrow">{tr("x.thank_you")}</div>
        <h1 style={{ fontFamily: "Outfit", fontSize: 34, margin: "12px 0 12px" }}>{tr("x.we_ve_got_your_details")}</h1>
        <p style={{ color: "var(--pub-muted)", marginBottom: 32 }}>
          {tr("x.one_of_our_team_will_call_you_within_24_")}
        </p>
        <a href="/cars" className="pub-cta" style={{ display: "inline-block" }}>{tr("x.meanwhile_browse_our_cars")}</a>
      </div>
    );
  }

  return (
    <div data-testid="sell-page">
      <section className="pub-sell-v2" style={{ padding: "140px 0 64px" }}>
        <div className="public-container sell-grid">
          <div>
            <div className="kicker on-sec">{tr("x.consign_with_us")}</div>
            <h1 className="sell-h">{t("sell.title")}</h1>
            <p className="sell-p">{t("sell.intro")}</p>
          </div>
          <form className="enquiry-form sell-form-v3" onSubmit={submit} data-testid="sell-form"
            style={{ background: "color-mix(in srgb, var(--s) 85%, #000)", padding: 32, display: "grid", gap: 10 }}>
            <input type="text" name="website" tabIndex={-1} autoComplete="off" style={{ display: "none" }} data-testid="sell-honeypot" />
            <div style={{ display: "grid", gap: 10, gridTemplateColumns: "1fr 1fr" }}>
              <input placeholder={t("enquiry.your_name")} required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="sell-name" />
              <input placeholder={t("enquiry.mobile")} required inputMode="tel" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} data-testid="sell-mobile" />
              <input placeholder={t("enquiry.email")} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="sell-email" style={{ gridColumn: "1 / -1" }} />
              <input placeholder={t("sell.make")} required value={form.make} onChange={(e) => setForm({ ...form, make: e.target.value })} data-testid="sell-make" />
              <input placeholder={t("sell.model")} required value={form.model} onChange={(e) => setForm({ ...form, model: e.target.value })} data-testid="sell-model" />
              <input placeholder={t("sell.year")} type="number" required value={form.year} onChange={(e) => setForm({ ...form, year: e.target.value })} data-testid="sell-year" />
              <input placeholder={t("sell.mileage")} type="number" value={form.mileage} onChange={(e) => setForm({ ...form, mileage: e.target.value })} data-testid="sell-mileage" />
            </div>
            <textarea placeholder={t("sell.notes")} value={form.condition_notes} onChange={(e) => setForm({ ...form, condition_notes: e.target.value })} data-testid="sell-notes" />
            <button type="submit" disabled={sending} data-testid="sell-submit" style={{ height: 64 }}>
              {sending ? t("enquiry.sending") : t("sell.submit")}
            </button>
          </form>
        </div>
      </section>
      <section style={{ background: "var(--surface)", padding: "72px 0" }}>
        <div className="public-container">
          <div className="kicker">{tr("x.how_it_works")}</div>
          <h2 style={{ fontSize: "clamp(32px,3.6vw,48px)", fontWeight: 300, letterSpacing: "-0.025em", margin: "10px 0 48px" }}>{tr("x.three_steps_no_runaround")}</h2>
          <div style={{ display: "grid", gap: 1, gridTemplateColumns: "repeat(3, 1fr)", background: "var(--rule)", border: "1px solid var(--rule)" }} className="sell-steps">
            {[
              { n: "01", t: tr("x.tell_us_about_the_car"), s: tr("x.fill_the_form_on_the_left_takes_60_secon") },
              { n: "02", t: tr("x.free_on_site_inspection"), s: tr("x.our_team_arrives_at_a_time_you_choose") },
              { n: "03", t: tr("x.written_offer_same_day"), s: tr("x.no_obligation_transfer_handled_by_us_if_") },
            ].map((it) => (
              <div key={it.n} style={{ background: "#fff", padding: 40 }}>
                <div style={{ fontSize: 15, color: "var(--grey-600)", fontWeight: 500 }}>{it.n}</div>
                <h3 style={{ fontSize: 28, fontWeight: 300, letterSpacing: "-0.02em", margin: "14px 0 10px" }}>{it.t}</h3>
                <p style={{ color: "var(--grey-600)", fontSize: 14, lineHeight: 1.55, margin: 0 }}>{it.s}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <style>{`@media (max-width:900px){.sell-steps{grid-template-columns:1fr !important;}}`}</style>
    </div>
  );
}
